import { autocomplete, getAlgoliaResults, AutocompleteComponents } from '@algolia/autocomplete-js';
import { AutocompleteInsightsApi } from '@algolia/autocomplete-plugin-algolia-insights';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import algoliasearch from 'algoliasearch/lite';
import { ProductHit } from './ProductHit';

const appId = city_algolia.appKey;
const apiKey = city_algolia.key;
const searchClient = algoliasearch(appId, apiKey);
var country_code = typeof baseCountry != 'undefined' ? baseCountry.toLowerCase() : 'ae'



function debouncePromise(fn, time) {
  let timerId = undefined;

  return function debounced(...args) {
    if (timerId) {
      clearTimeout(timerId);
    }

    return new Promise((resolve) => {
      timerId = setTimeout(() => resolve(fn(...args)), time);
    });
  };
}
const debounced = debouncePromise((items) => Promise.resolve(items), 300);


$(document).ready(function () {


  $("#deliveryToModal").on("keypress", ".aa-Input", function (event) {
    var regex = new RegExp("^[&+\u0621-\u064Aa-zA-Z0-9\u0660-\u0669 .\b]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key) && !(event.key === 'Enter' || event.keyCode === 13)) {
      event.preventDefault();
      return false;
    }
  })

  $("#deliveryToModal").on("input", ".header-state-search .aa-Input", function (event) {
    
    if(window.state_input_manually_set){
      window.state_input_manually_set = false
      return
    }

    var regex = new RegExp("^[&+\u0621-\u064Aa-zA-Z0-9\u0660-\u0669 .\b]+$");
    var inp = event.target
    var val = inp.value

    if (!regex.test(val)) {``
    header_state_search.setQuery("");
    header_state_search.setIsOpen(false)
    }
    inp.value = val.replace(/[^&+\u0621-\u064AA-Za-z0-9\u0660-\u0669 .]+/g, "")
    window.state_input_manually_set = true
    var event = new Event('input');
    $(".header-state-search .aa-Input")[0].dispatchEvent(event)
    $(".header-state-search .aa-Input").trigger("input")

  })

  $("#deliveryToModal").on("input", ".header-area-search .aa-Input", function (event) {
    
    if(window.area_input_manually_set){
      window.area_input_manually_set = false
      return
    }

    var regex = new RegExp("^[&+\u0621-\u064Aa-zA-Z0-9\u0660-\u0669 .\b]+$");
    var inp = event.target
    var val = inp.value

    if (!regex.test(val)) {``
    header_area_search.setQuery("");
    header_area_search.setIsOpen(false)
    }
    inp.value = val.replace(/[^&+\u0621-\u064AA-Za-z0-9\u0660-\u0669 .]+/g, "")
    var event = new Event('input');
    window.area_input_manually_set = true
    $(".header-area-search .aa-Input")[0].dispatchEvent(event)
    $(".header-area-search .aa-Input").trigger("input")

  })

  

  var base_filter = "active:true AND country_code:"+country_code
  var state_algoliaFilters = base_filter
  if($("#deliveryToModal .ui-address__list.selected").length == 0 ){
    $(".area-select-apply .btn").attr("data-state", $("#deliveryToModal").attr("data-state-code"))
    $(".area-select-apply .btn").attr("data-city", $("#deliveryToModal").attr("data-city-code"))
  }
  window.header_state_search = autocomplete<ProductHit>({
    container: '.header-state-search',
    panelContainer: '.header-state-search',
    placeholder: $.validator.messages.select_state,
    detachedMediaQuery: 'none',
    stallThreshold: 300,
    openOnFocus: true,
    initialState: {
     query: $("#deliveryToModal .ui-address__list.selected").length > 0 ? "" : $("#deliveryToModal").attr("data-state-name")
    },
    onStateChange: function (props) {
     
    },
    plugins:  [],
    onSubmit({ state }) {
      
    },
    onReset({ state }) {
      area_algoliaFilters = base_filter
      $(".area-select-apply .btn").attr("data-state", "")
    },
    getSources({ query, state }) {
      // if (!query) {
      //   return [];
      // }
    
      return debounced([
        {
          sourceId: 'state',
          onSelect: function (props) {
            area_algoliaFilters = base_filter + " AND state_code:"+ props.item.state_code
            header_state_search.setQuery(props.item.state_name_en)
            if(current_locale == 'ar'){
              header_state_search.setQuery(props.item.state_name_ar)
            }
           
            header_area_search.setQuery("")
            $(".area-select-apply .btn").attr("data-state", props.item.state_code)
            $(".area-select-apply .btn").attr("data-city", "")
          },
          getItems() {
            return getAlgoliaResults<ProductHit>({
              searchClient,
              queries: [
                {
                  indexName: city_algolia.index,
                  query,
                  params: {
                    hitsPerPage: 1000,
                    restrictSearchableAttributes: ['state_name_en','state_name_ar'],
                    distinct:true,
                    filters: state_algoliaFilters,
                  //  attributesToRetrieve:   "permalink,permalink_ar,post_title,post_id,post_title_ar,main_sku,taxonomies.taxonomies_hierarchical.product_cat,taxonomies_ar.product_cat,taxonomies.product_brand,taxonomies_ar.product_brand,discount,discount_val,images,price,promotion_offer_json,regular_price,sale_price,in_stock,rating_reviews",
                    getRankingInfo: 1,
              //      attributesToHighlight: "post_title,post_title_ar",
                    //maxValuesPerFacet: 5,
                    clickAnalytics: true
                  },
                },
              ],
            });
          },
          templates: {
            item(props) {
              const { item, components } = props
              return (
                <ProductItem
                  hit={item}
                  type="state"
                  components={components}
                />
              );
            },
            noResults() {
              return "No results found"
            },
          },
        },
      ])
    },
  });

  var area_algoliaFilters = base_filter
  if($("#deliveryToModal").attr("data-state-code") && $("#deliveryToModal .ui-address__list.selected").length  == 0){
    area_algoliaFilters += " AND state_code:"+$("#deliveryToModal").attr("data-state-code")
  }
  
  window.header_area_search = autocomplete<ProductHit>({
    container: '.header-area-search',
    panelContainer: '.header-area-search',
    placeholder: $.validator.messages.select_city,
    detachedMediaQuery: 'none',
    stallThreshold: 300,
    openOnFocus: true,
    initialState: {
      query: $("#deliveryToModal .ui-address__list.selected").length > 0 ? "" : $("#deliveryToModal").attr("data-city-name")
    },
    onStateChange: function (props) {
     
    },
    plugins:  [],
    onReset({ state }) {
      $(".area-select-apply .btn").attr("data-city", "")
    },
    getSources({ query, state }) {
      if (!query && !$(".area-select-apply .btn").attr("data-state")) {
        return [];
      }
      
      return debounced([
        {
          sourceId: 'area',
          onSelect: function (props) {
          
          
            if(current_locale == 'ar'){
              if(sdg_shipping_eta_config.is_city_enable){
                header_area_search.setQuery(props.item.city_name_ar)
              }
              if(sdg_shipping_eta_config.is_area_enable){
                header_area_search.setQuery(props.item.name_ar)
              }
              header_state_search.setQuery(props.item.state_name_ar)
            } else {
              if(sdg_shipping_eta_config.is_city_enable){
                header_area_search.setQuery(props.item.city_name_en)
              }
              if(sdg_shipping_eta_config.is_area_enable){
                header_area_search.setQuery(props.item.name_en)
              }
              
              header_state_search.setQuery(props.item.state_name_en)
            }
            area_algoliaFilters = base_filter + " AND state_code:"+props.item.state_code
            $(".area-select-apply .btn").attr("data-state",  props.item.state_code)
            if(sdg_shipping_eta_config.is_city_enable){
              $(".area-select-apply .btn").attr("data-city", props.item.city_code)
            }
            if(sdg_shipping_eta_config.is_area_enable){
              $(".area-select-apply .btn").attr("data-city", props.item.code)
            }

          },
          getItems() {
            var restrictSearchableAttributes = ['city_name_en','city_name_ar'];
            if(sdg_shipping_eta_config.is_area_enable){
              restrictSearchableAttributes = ['name_en','name_ar'];
            }
            
            return getAlgoliaResults<ProductHit>({
              searchClient,
              queries: [
                {
                  indexName: city_algolia.city_index,
                  query,
                  params: {
                    hitsPerPage: 1000,
                    restrictSearchableAttributes: restrictSearchableAttributes,
                    filters: area_algoliaFilters,
                  //  attributesToRetrieve:   "permalink,permalink_ar,post_title,post_id,post_title_ar,main_sku,taxonomies.taxonomies_hierarchical.product_cat,taxonomies_ar.product_cat,taxonomies.product_brand,taxonomies_ar.product_brand,discount,discount_val,images,price,promotion_offer_json,regular_price,sale_price,in_stock,rating_reviews",
                    getRankingInfo: 1,
              //      attributesToHighlight: "post_title,post_title_ar",
                   // maxValuesPerFacet: 5,
                    clickAnalytics: true
                  },
                },
              ],
            });
          },
          templates: {
            item(props) {
              const { item, components } = props
              return (
                <ProductItem
                  hit={item}
                  type={sdg_shipping_eta_config.is_area_enable ? 'area':'city'}
                  components={components}
                />
              );
            },
            noResults() {
              return "No results found"
            },
          },
        },
      ])
    },
  });

})




type ProductItemProps = {
  hit: ProductHit;
  components: AutocompleteComponents;
  type:string;
};

function ProductItem({ hit, components, type }: ProductItemProps) {
  console.log(hit.country_code);
  return (
      <div className="aa-ItemContent">
        <div className="aa-ItemContentBody">
          <div className="aa-ItemContentTitle">
          { current_locale == 'ar' && type=="state" && hit.state_name_ar}
          {current_locale != 'ar' && type=="state" && hit.state_name_en}
          {hit.country_code != 'sa' && current_locale == 'ar' && type=="area" && hit.name_ar}
          {hit.country_code === 'sa' && type === "area" && (
  <>
    {current_locale !== 'ar' && (
      <>
        {hit.city_name_en && hit.name_en
          ? (
            <>
              {hit.name_en} - <span style={{ color: '#999' }}>{hit.city_name_en}</span>
            </>
          )
          : hit.name_en || hit.city_name_en}
      </>
    )}
    {current_locale === 'ar' && (
      <>
        {hit.city_name_ar && hit.name_ar
          ? (
            <>
              {hit.name_ar} - <span style={{ color: '#999' }}>{hit.city_name_ar}</span>
            </>
          )
          : hit.name_ar || hit.city_name_ar}
      </>
    )}
  </>
)}

          {hit.country_code != 'sa' && current_locale == 'ar' && type=="area" && hit.name_ar}
          {hit.country_code != 'sa' && current_locale != 'ar' && type=="area" && hit.name_en}
          {current_locale == 'ar' && type=="city" && hit.city_name_ar}
          { current_locale != 'ar' && type=="city" && hit.city_name_en}
          </div>
        </div>
      </div>
  
  );
}